export const selectCurrentUser = (state) => state.user.currentUser;
export const selectOrgList = (state) => state.user.currentUser?.orgList;
export const selectUserReducer = (state) => state.user;
export const selectCurrentUsername = (state) => state.user.currentUser.userName;
export const selectCurrentUserscore = (state) => state.user.currentUser?.points;
